export default __webpack_public_path__ + "static/media/spesial-offer.3a879b2c.svg";